module.exports = __webpack_public_path__ + "static/media/stacked-bar-chart.778aeea5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/stacked-bar-chart.svg
// module id = ./src/assets/icons/stacked-bar-chart.svg
// module chunks = 0